export interface ScreenPoint { x: number; y: number }
/** CSS pixels, independent of renderer resolution and device pixel ratio. */
export function isSelectionDrag(start: ScreenPoint, end: ScreenPoint, pointerType = 'mouse') {
  const width = Math.abs(end.x - start.x), height = Math.abs(end.y - start.y);
  const threshold = pointerType === 'touch' ? 22 : 14;
  // A small diagonal twitch or a narrow wobble should remain a click.
  return Math.hypot(width, height) >= threshold && (Math.min(width, height) >= 6 || Math.max(width, height) >= threshold * 2);
}
